var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("FormItem", {
    scopedSlots: _vm._u([
      {
        key: "question",
        fn: function () {
          return [_vm._v("Registration Details")]
        },
        proxy: true,
      },
      {
        key: "response",
        fn: function () {
          return [
            _c(
              "v-list",
              { staticClass: "pa-0" },
              [
                _c(
                  "v-list-item",
                  { staticClass: "px-2", attrs: { "two-line": "" } },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "justify-start flex" },
                          [_vm._v(_vm._s(_vm.tuition.product.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-subtitle",
                          { staticClass: "justify-start flex" },
                          [
                            _vm._v(
                              "\n                        Due 30 days before camp\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-list-item-action", [
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.formatUnitAmount(
                                _vm.tuition.unit_amount -
                                  _vm.deposit.unit_amount
                              )
                            ) +
                            "/person\n                    "
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-item",
                  { staticClass: "px-2", attrs: { "two-line": "" } },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "justify-start flex" },
                          [_vm._v(_vm._s(_vm.deposit.product.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-subtitle",
                          { staticClass: "justify-start flex" },
                          [
                            _vm._v(
                              "\n                        Due today\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-list-item-action", [
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.formatUnitAmount(_vm.deposit.unit_amount)
                            ) +
                            "/person\n                    "
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }